'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

interface Props {
  enabled: boolean | string;
  children: React.ReactNode;
}

const GoogleCaptchaWrapper = ({ children, enabled }: Props) => {
  const reCaptchaKey = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || '';
  if (enabled === true || enabled === 'true') {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        {children}
      </GoogleReCaptchaProvider>
    );
  }

  return <>{children}</>;
};

export default GoogleCaptchaWrapper;
